import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { sectionRenderer } from '@theme/section-renderer';

/** @type {Map<string, Promise<string>>} */
const pendingSectionRenders = new Map();

/**
 * Displays variant metafield content and re-renders when the selected variant changes.
 * Uses the Section Rendering API because metafield values are not included
 * in the client-side variant update event payload.
 *
 * Uses hydration mode so only this block updates — not the full section (which would
 * reset the Affirm app block's promo markup).
 */
class VariantMetafieldContent extends Component {
  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
    if (target) {
      target.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
    } else {
      document.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
    if (target) {
      target.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
    } else {
      document.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
    }
  }

  #handleVariantUpdate = () => {
    const sectionId = this.dataset.sectionId;
    if (!sectionId) return;

    if (!pendingSectionRenders.has(sectionId)) {
      const renderPromise = sectionRenderer
        .renderSection(sectionId, { cache: false, mode: 'hydration' })
        .finally(() => {
          pendingSectionRenders.delete(sectionId);
        });

      pendingSectionRenders.set(sectionId, renderPromise);
    }
  };
}

if (!customElements.get('variant-metafield-content')) {
  customElements.define('variant-metafield-content', VariantMetafieldContent);
}
